import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { GetCurrentUserAction } from '../../actions/current-user/get-current-user-action';
import { map, mergeMap } from 'rxjs/operators';
import { GetCurrentUserSuccessAction } from '../../actions/current-user/get-current-user-success-action';
import { GetCurrentUserErrorAction } from '../../actions/current-user/get-current-user-error-action';
import { CurrentAccountState } from '../../states/current-account-state';
import { Store } from '@ngrx/store';
import { CurrentAccountSelector } from '../../selectors/current-account-selector';
import { whenLoaded } from '../../../helpers/when-loaded';
import { BijbAccount } from '../../../models/bijb-account';
import { User } from '../../../models/user';
import { Role } from '../../../models/role';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable()
export class GetCurrentUserEffect {

  private account: BijbAccount;

  constructor(private api: ApiService,
    private actions: Actions,
    private currentAccountStateStore: Store<CurrentAccountState>) {
    whenLoaded(this, this.currentAccountStateStore, CurrentAccountSelector)
      .pipe(map(state => state.account))
      .subscribe(acc => {
        this.account = acc;
      });
  }


  public GetCurrentUser = createEffect(() => this.actions
    .pipe(
      ofType(GetCurrentUserAction.type),
      mergeMap(action => {
        const getCurrentUserAction = <GetCurrentUserAction>action;
        return this.api.getCurrentUser(getCurrentUserAction.bijbEvent).then(user => {
          return new GetCurrentUserSuccessAction(user);
        }, error => {
          if (this.account.isAdmin) {
            const user = new User();
            user.firstName = this.account.firstName;
            user.lastName = this.account.lastName;
            user.role = Role.Admin;
            user.emailAddress = this.account.emailAddress;
            user.accountId = this.account.id;
            user.createdAt = this.account.createdAt;
            user.registered = true;
            return new GetCurrentUserSuccessAction(user);
          }

          return new GetCurrentUserErrorAction(error);
        });
      })
    ));
}
